function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable class-methods-use-this */

/**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */

import Translator from '@uppy/utils/lib/Translator';

/**
 * DefinePluginOpts marks all of the passed AlwaysDefinedKeys as “required” or “always defined”.
 */
var BasePlugin = /*#__PURE__*/function () {
  function BasePlugin(uppy, opts) {
    _classCallCheck(this, BasePlugin);
    this.uppy = uppy;
    this.opts = opts != null ? opts : {};
  }
  _createClass(BasePlugin, [{
    key: "getPluginState",
    value: function getPluginState() {
      var _this$uppy$getState = this.uppy.getState(),
        plugins = _this$uppy$getState.plugins;
      return (plugins == null ? void 0 : plugins[this.id]) || {};
    }
  }, {
    key: "setPluginState",
    value: function setPluginState(update) {
      var _this$uppy$getState2 = this.uppy.getState(),
        plugins = _this$uppy$getState2.plugins;
      this.uppy.setState({
        plugins: _objectSpread(_objectSpread({}, plugins), {}, _defineProperty({}, this.id, _objectSpread(_objectSpread({}, plugins[this.id]), update)))
      });
    }
  }, {
    key: "setOptions",
    value: function setOptions(newOpts) {
      this.opts = _objectSpread(_objectSpread({}, this.opts), newOpts);
      this.setPluginState(undefined); // so that UI re-renders with new options
      this.i18nInit();
    }
  }, {
    key: "i18nInit",
    value: function i18nInit() {
      var translator = new Translator([this.defaultLocale, this.uppy.locale, this.opts.locale]);
      this.i18n = translator.translate.bind(translator);
      this.i18nArray = translator.translateArray.bind(translator);
      this.setPluginState(undefined); // so that UI re-renders and we see the updated locale
    }

    /**
     * Extendable methods
     * ==================
     * These methods are here to serve as an overview of the extendable methods as well as
     * making them not conditional in use, such as `if (this.afterUpdate)`.
     */

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "addTarget",
    value: function addTarget(plugin) {
      throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
  }, {
    key: "install",
    value: function install() {}
  }, {
    key: "uninstall",
    value: function uninstall() {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "update",
    value: function update(state) {}

    // Called after every state update, after everything's mounted. Debounced.
  }, {
    key: "afterUpdate",
    value: function afterUpdate() {}
  }]);
  return BasePlugin;
}();
export { BasePlugin as default };